



































































import { Vue, Component } from 'vue-property-decorator';
import RegisterAdminCard from '@/components/public/RegisterAdminCard.vue';
import RegisterBrandStepOne from '@/components/brand/RegisterBrandCard.vue';
import RegisterBrandStepTwo from '@/components/brand/RegisterBrandStepTwo.vue';
import RegisterBrandStepThree from '@/components/brand/RegisterBrandStepThree.vue';

import {
  BrandWrite,
} from '../../common/types';
import adminModule from '../../store/modules/admin.module';
import brandModule from '../../store/modules/brand.module';
import { eventBus } from '../../main';
import { REGISTER_ADMIN } from '../../common/constants';
import { ADMIN_BRAND_ASSETS } from '../../common/routes.config';
import errorModule from '../../store/modules/error.module';

enum RegistrationStage {
  RegisterUser,
  RegisterBrandStepOneStage,
  RegisterBrandStepTwoStage,
  RegisterBrandStepThreeStage,
  RegisterBrandLoading,
  RegisterFinish
}

@Component({
  components: {
    RegisterAdminCard,
    RegisterBrandStepOne,
    RegisterBrandStepTwo,
    RegisterBrandStepThree,
  },
})
export default class RegisterBrand extends Vue {
  snackMessage = '';

  brand: BrandWrite = {
    name: '',
    logo: '',
    website: '',
    primary_color: '',
    secondary_color: '',
    description: '',
  };

  isSubmitted = false;

  currentRegisterStage: RegistrationStage = RegistrationStage.RegisterUser;

  registerationStage: any = RegistrationStage;

  created(): void {
    eventBus.$on(REGISTER_ADMIN, this.adminHasBeenRegistered);
  }

  adminHasBeenRegistered(): void {
    this.currentRegisterStage = RegistrationStage.RegisterBrandStepOneStage;
  }

  validateStepOne(brand: BrandWrite): void {
    this.brand.name = brand.name;
    this.brand.description = brand.description;
    this.brand.website = brand.website;
    this.currentRegisterStage = RegistrationStage.RegisterBrandStepTwoStage;
  }

  async validateStepTwo(payload): Promise<void> {
    const { brand } = payload;
    const { logo } = payload;
    this.brand.facebook = brand.facebook;
    this.brand.instagram = brand.instagram;
    this.brand.twitter = brand.twitter;
    this.brand.youtube = brand.youtube;
    this.brand.linkedin = brand.linkedin;
    this.brand.primary_color = brand.primary_color;
    this.brand.secondary_color = brand.secondary_color;
    this.brand.logo = brand.logo;
    await brandModule.createBrand({
      brand: this.brand,
      logo,
    });
    if (errorModule.hasError) {
      errorModule.clearError();
      return;
    }
    if (adminModule.admin && brandModule.brand) {
      await adminModule.setAdminBrand({
        adminId: adminModule.admin.id,
        brandId: brandModule.brand.id,
      });
      if (errorModule.hasError) {
        errorModule.clearError();
        return;
      }
    }

    eventBus.$emit('fetchDispensaries');
    this.currentRegisterStage = RegistrationStage.RegisterBrandStepThreeStage;
  }

  // Dispensaries have successfully been added to brand.
  async registrationCompleted(): Promise<void> {
    this.currentRegisterStage = RegistrationStage.RegisterBrandLoading;
    setTimeout(() => {
      this.currentRegisterStage = RegistrationStage.RegisterFinish;
      this.cueConfetti();
      this.$router.push(ADMIN_BRAND_ASSETS);
    }, 2500);
  }

  cueConfetti(): void {
    const vueInstance = this as any;
    vueInstance.$confetti.start();
    setTimeout(() => {
      vueInstance.$confetti.stop();
    }, 4000);
  }
}
